import { render, staticRenderFns } from "./MessageTest.vue?vue&type=template&id=d1a412f6&"
import script from "./MessageTest.vue?vue&type=script&lang=js&"
export * from "./MessageTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports